import { useRef } from 'react';

import { HighlightedPrice, Sparkline } from 'design-system';

// oxlint-disable-next-line gx-boundaries/no-cross-feature-import -- Preserve the dashboard-owned widget animation contract.
import { ElectricBorder, useScrollToAnimatedElement } from '@/features/dashboard';
// oxlint-disable-next-line gx-boundaries/no-cross-feature-import -- FactsheetDialogButton is the approved factsheet stop boundary for market widgets.
import { FactsheetDialogButton } from '@/features/factsheet';

import type { TileType } from '../../../types';

const Tile = ({ tile }: { tile: TileType }) => {
  const { code, shortTitle, value, delta, deltaPercentage, sparkline } = tile;
  const ref = useRef<HTMLDivElement>(null);
  const isAnimating = useScrollToAnimatedElement(ref, tile.id);
  const numericDelta = Number(delta);
  // oxlint-disable-next-line sonarjs/no-nested-conditional -- Keep the canonical three-way trend mapping adjacent to the single numeric conversion.
  const trend = numericDelta > 0 ? 'up' : numericDelta < 0 ? 'down' : 'neutral';
  const titleWithFactsheetAction = (
    <span className='inline-flex min-w-0 items-center gap-1'>
      {shortTitle}
      <FactsheetDialogButton
        showTooltip
        code={code}
        fontSize={14}
      />
    </span>
  );

  return (
    <ElectricBorder animate={isAnimating}>
      <div ref={ref}>
        <HighlightedPrice
          code={code || 'GXCODE'}
          title={titleWithFactsheetAction}
          price={value}
          delta={`${delta} (${deltaPercentage}%)`}
          trend={trend}
          chart={
            sparkline ? (
              <Sparkline
                points={sparkline}
                trend={trend}
              />
            ) : undefined
          }
        />
      </div>
    </ElectricBorder>
  );
};

export default Tile;
